import { useMutation, useQueryClient } from 'react-query';

import { applianceQueryKeys } from '../QueryKeys';
import useApiHelper from '../../hooks/useApiHelper';
import { IApplianceType } from '../../types/Appliance/ApplianceType';
import { useDefaultMutateResponseHandlers } from '../../hooks/useDefaultMutateResponeHandlers';

export default function useApplianceTypeMutations() {
  const queryClient = useQueryClient();
  const { post, put, del } = useApiHelper();
  const { handleSuccess, handleError } =
    useDefaultMutateResponseHandlers('Appliance Type');

  const createApplianceType = useMutation({
    mutationFn: (applianceType: IApplianceType) =>
      post('/v1/superadmin/hardware/types', applianceType),
    onError: (error) => handleError(error, 'create'),
    onSuccess: (data) => handleSuccess(data, 'create'),
    onSettled: () => {
      queryClient.invalidateQueries(applianceQueryKeys.types());
      queryClient.invalidateQueries(applianceQueryKeys.superAdminTypes());
    },
  });

  const updateApplianceType = useMutation({
    mutationFn: (applianceType: IApplianceType) =>
      put(`/v1/superadmin/hardware/types/${applianceType.id}`, applianceType),
    onError: (error) => handleError(error, 'update'),
    onSuccess: (data) => handleSuccess(data, 'update'),
    onSettled: () => {
      queryClient.invalidateQueries(applianceQueryKeys.types());
      queryClient.invalidateQueries(applianceQueryKeys.superAdminTypes());
    },
  });

  const delApplianceType = useMutation({
    mutationFn: (applianceType: IApplianceType) =>
      del(`/v1/superadmin/hardware/types/${applianceType.id}`),
    onError: (error) => handleError(error, 'delete'),
    onSuccess: (data) => handleSuccess(data, 'delete'),
    onSettled: () => {
      queryClient.invalidateQueries(applianceQueryKeys.types());
      queryClient.invalidateQueries(applianceQueryKeys.superAdminTypes());
    },
  });

  return {
    createApplianceType,
    updateApplianceType,
    delApplianceType,
  };
}
